import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'
import validator from 'validator'
import { capitalize } from '../../../utils/helpers'

//Components
import Title from '../../step/title/title'
import Input from '../../step/input/input'
import Button from '../../step/button/button'
import InfoTag from '../../step/infotag/infotag'
import SubTitle from '../../step/title/subtitle'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  ${media.md`
    flex-direction: row; 
    margin-top: 40px;
`};
`
const Card = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px 0;
  padding: 30px 40px;
  border: solid 1px #ffffff;
  ${media.md`
    flex-direction: row; 
`};
`

class StepContact extends React.Component {
  state = {
    isError: false
  }
  _onNextPress = () => {
    const { primaryContact, updatePrimaryContact, nextStep } = this.props

    if (validator.isEmpty(primaryContact.name.trim())) {
      primaryContact.name = ''
      updatePrimaryContact(primaryContact)
      this.setState({ isError: true })
    } else if (!validator.isEmail(primaryContact.email.trim())) {
      primaryContact.email = ''
      updatePrimaryContact(primaryContact)
      this.setState({ isError: true })
    } else if (!validator.isNumeric(primaryContact.phone)) {
      primaryContact.phone = ''
      updatePrimaryContact(primaryContact)
      this.setState({ isError: true })
    } else {
      nextStep()
    }
  }

  _onChangePrimaryNameInput = event => {
    const { updatePrimaryContact, primaryContact } = this.props
    primaryContact.name = capitalize(event.target.value)
    updatePrimaryContact(primaryContact)
  }
  _onChangePrimaryPhoneInput = event => {
    const { updatePrimaryContact, primaryContact } = this.props
    primaryContact.phone = event.target.value
    updatePrimaryContact(primaryContact)
  }

  _onChangePrimaryEmailInput = event => {
    const { updatePrimaryContact, primaryContact } = this.props
    primaryContact.email = capitalize(event.target.value)
    updatePrimaryContact(primaryContact)
  }

  _onChangeSecodaryNameInput = event => {
    const { updateSecondaryContact, secondaryContact } = this.props
    secondaryContact.name = capitalize(event.target.value)
    updateSecondaryContact(secondaryContact)
  }
  _onChangeSecodaryPhoneInput = event => {
    const { updateSecondaryContact, secondaryContact } = this.props
    secondaryContact.phone = event.target.value
    updateSecondaryContact(secondaryContact)
  }

  _onChangeSecodaryEmailInput = event => {
    const { updateSecondaryContact, secondaryContact } = this.props
    secondaryContact.email = capitalize(event.target.value)
    updateSecondaryContact(secondaryContact)
  }

  _keyPressEnter = event => {
    if (event.key === 'Enter') {
      this._onNextPress()
    }
  }

  render() {
    const { isError } = this.state
    const { currentStep, primaryContact, job } = this.props
    return 3 != currentStep ? null : (
      <div
        className="col-sm-8 col-md-12 col-sm-10 col-lg-8"
        style={{ margin: 'auto' }}
      >
        <Title title="Ayúdanos con dos números de telefónicos para ponernos en contacto 	contigo en el menor tiempo posible" />

        <div className="row">
          <div className="col-md-5">
            <SubTitle title="Contacto 1" />
            <Card>
              <div className="row">
                <div className="col-12">
                  <SubTitle title="Persona de contacto" />
                  <Input
                    onChange={this._onChangePrimaryNameInput}
                    placeholder="Nombre"
                    onKeyPress={this._keyPressEnter}
                  />
                </div>
                <div className="col-12">
                  <SubTitle title="Número de contacto" />
                  <Input
                    onChange={this._onChangePrimaryPhoneInput}
                    placeholder="Número"
                    onKeyPress={this._keyPressEnter}
                  />
                </div>
                <div className="col-12">
                  <SubTitle title="Correo Electrónico" />
                  <Input
                    onChange={this._onChangePrimaryEmailInput}
                    placeholder="Correo"
                    onKeyPress={this._keyPressEnter}
                  />
                </div>
              </div>
            </Card>
          </div>
          <div className="col-md-1" />
          <div className="col-md-5">
            <SubTitle title="Contacto 2" />
            <Card>
              <div className="row">
                <div className="col-12">
                  <SubTitle title="Persona de contacto" />
                  <Input
                    onChange={this._onChangeSecodaryNameInput}
                    placeholder="Nombre"
                    onKeyPress={this._keyPressEnter}
                  />
                </div>
                <div className="col-12">
                  <SubTitle title="Número de contacto" />
                  <Input
                    onChange={this._onChangeSecodaryPhoneInput}
                    placeholder="Número"
                    onKeyPress={this._keyPressEnter}
                  />
                </div>
                <div className="col-12">
                  <SubTitle title="Correo Electrónico" />
                  <Input
                    onChange={this._onChangeSecodaryEmailInput}
                    placeholder="Correo"
                    onKeyPress={this._keyPressEnter}
                  />
                </div>
              </div>
            </Card>
          </div>
        </div>

        <Wrapper>
          <div>
            <Button onClick={this._onNextPress} title="Siguiente" />
            <SubTitle title="O presione ENTER" />
          </div>
          {isError ? (
            <InfoTag message="&times; Cuéntanos tu función en tu empresa" />
          ) : null}
        </Wrapper>
      </div>
    )
  }
}

export default StepContact



// WEBPACK FOOTER //
// ./src/components/contactus/steps/StepContact.js